export default "/images/vendor/flag-icon-css/flags/4x3/mn.svg?e3dad1d36409c092e6a54b64cac046fe";